'use strict';

var util = require('../services/tracking/blz-tracking-util');
var blzEvent = require('../services/tracking/blz-event.js');
var HTTPService = require('../services/http-service');

var $cookiePolicy = document.querySelector('.cookiepolicy');
var $cookieAccept = document.querySelector('.cookiepolicy-accept');

var CookiePolicy = {
  onConsentChangedOneTrust: function onConsentChangedOneTrust() {
    const hasOneTrust = typeof window.OneTrust !== 'undefined';

    hasOneTrust &&
      window.OneTrust.OnConsentChanged((evt) => {
        blzEvent.interaction(
          {},
          {
            category: (blz.pageName || '').toUpperCase(),
            action: 'Button-Click',
            label: 'Accept-Cookies-Policy',
            values: `detail:${evt.detail.join('|')};trusted:${evt.isTrusted};`
          }
        );
      });
  },

  show: function show() {
    var isBlacklist = /\/minha-conta\/|webview=true/i.test(location.href);
    if (!CookiePolicy.hasAccept() && $cookiePolicy && !isBlacklist) {
      $cookiePolicy.classList.add('bottom-up');
      CookiePolicy.init();
    }
  },

  hide: function hide() {
    $cookiePolicy && $cookiePolicy.classList.remove('bottom-up');
  },

  storeAccept: function storeAccept() {
    var oneYear = 365 * 24 * 60 * 60 * 1000;
    document.cookie = util.setCookie(
      'cookiepolicy-accept',
      '{necessary: true, partners: true, analytics: true}',
      oneYear
    );
    blz.me.id && HTTPService.put('/api/opt-ins/update', { key: 'cookiesPolicy', value: true });
  },

  hasAccept: function hasAccept() {
    return util.readCookie('cookiepolicy-accept') || (blz.me.opts || {}).cookiePolicy;
  },

  accept: function accept() {
    CookiePolicy.storeAccept();
    CookiePolicy.hide();
    blzEvent.interaction(
      {},
      {
        category: (blz.pageName || '').toUpperCase(),
        action: 'Button-Click',
        label: 'Accept-Cookies-Policy'
      }
    );
  },

  init: function init() {
    $cookieAccept && $cookieAccept.addEventListener('click', CookiePolicy.accept, false);
    blzEvent.interaction(
      {},
      {
        category: (blz.pageName || '').toUpperCase(),
        action: 'pageView',
        label: 'View-Cookies-Policy'
      }
    );
  }
};

CookiePolicy.onConsentChangedOneTrust();

setTimeout(function () {
  CookiePolicy.show();
}, 3000);

module.exports = CookiePolicy;
